import styles from './companies.module.css';
import MediumHero from './hero/mediumHero';
import CTA from './cta/cta';
import Hero from './hero/hero';
import { Link } from 'react-router-dom';

const Companies = () => {
    return (
        <div className={styles.CompaniesContainer}>
            <MediumHero 
                imageUrl="https://images.unsplash.com/photo-1763041821558-71301407ded8" 
                altText="Súkklumynd"

            />
            <h2>Til feløg og myndugleikar</h2>
            <p>Sum felag ella myndugleiki, eru tað nógvir mátar, ið tú kanst verða við at fremja súkklu- og gongumentanina í Havnini. Tildømis kann man:</p>
            <ul>
                <li>bjóða starvsfólkum súkklur til flutning í arbeiðsørindum</li>
                <li>skipa parkeringsmøguleikar fyri súkklur á arbeiðsstaðnum</li>
            </ul>
            <p>Tað eru fleiri og fleiri, ið velja at súkkla ella ganga til og frá arbeiði, skúla og frítíðarítriv. Hetta eru løtur, ið starvsfólk kunnu njóta. Tí kann tað fyri fleiri skiljast sum ein starvsfólkaágóði at bjóða góðar umstøður fyri súkklur og gongufólk.</p>
            <Hero
                imageUrl="https://images.unsplash.com/photo-1582181704697-5fcaad5e6443"
                altText="Súkklumynd"
            />
            <p>Umframt at bjóða starvsfólkunum hesar ágóðar, kunnu tað eisini fyrimunir fyri virksemi hjá tær. Tildømis slepst undan at brúka tíð uppá at leita eftir parkingsplássum í arbeiðstíð. Eisini eru tað nógvir pengar at spara um ein el-súkkla kann koma ístaðin fyri tann næsta ella triðja bilin í felagnum.</p>
            <CTA
                text="Tekur tú undir við okkara arbeiði og hugsjón, heita vit á teg um at:"
                CTA={[ 
                    <>vísa okkum undirtøku á <Link to="/limir">hesari leinkjuni</Link></>,
                    "sum myndugleiki, hava okkum við sum hoyringspart í verkætlanum"
                ]}
            />
        </div>
    );
};

export default Companies;